import ListKeyFiguresByIndustryBox from './ListKeyFiguresByIndustryBox'

export default ListKeyFiguresByIndustryBox
